module.exports = "/static/assets/36bc26581a9e802c2eec7be5f9de15b2.png";